import cn from 'classnames'
import React, { ComponentProps } from 'react'

type MccMailPhoneOrderIconProps = {
  className?: string
} & ComponentProps<'svg'>

export default function MccMailPhoneOrderIcon(
  props: MccMailPhoneOrderIconProps,
) {
  const { className = '', ...rest } = props
  return (
    <svg
      className={cn('MccMailPhoneOrderIcon', className)}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M1.33331 3.66675L6.77659 7.47704C7.21737 7.78559 7.43776 7.93986 7.67749 7.99962C7.88924 8.0524 8.11072 8.0524 8.32247 7.99962C8.5622 7.93986 8.78259 7.78559 9.22337 7.47704L14.6666 3.66675M4.53331 12.3334H11.4666C12.5868 12.3334 13.1468 12.3334 13.5746 12.1154C13.951 11.9237 14.2569 11.6177 14.4487 11.2414C14.6666 10.8136 14.6666 10.2535 14.6666 9.13341V4.86675C14.6666 3.74664 14.6666 3.18659 14.4487 2.75877C14.2569 2.38244 13.951 2.07648 13.5746 1.88473C13.1468 1.66675 12.5868 1.66675 11.4666 1.66675H4.53331C3.41321 1.66675 2.85316 1.66675 2.42533 1.88473C2.04901 2.07648 1.74305 2.38244 1.5513 2.75877C1.33331 3.18659 1.33331 3.74664 1.33331 4.86675V9.13341C1.33331 10.2535 1.33331 10.8136 1.5513 11.2414C1.74305 11.6177 2.04901 11.9237 2.42533 12.1154C2.85316 12.3334 3.41321 12.3334 4.53331 12.3334Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
